import React, { useState } from 'react';

import Draggable from 'react-draggable';
import Paper, { PaperProps } from '@mui/material/Paper';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import styled from 'styled-components';

import CustomButton from '../../CustomViews/Elements/CustomButton';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';

import { MaintenanceModeConfirmationDialogModel } from '../../Models/InstanceManagement/InstanceManagement';

const CustomDialogContent = styled(DialogContent) <{ }>`
    width: '20vw';
    font-size: 14px;
    
    .instanceName {
        font-weight: 600;
    }
`;

function DraggablePaperComponent(props: PaperProps) {
    const nodeRef = React.useRef<HTMLDivElement>(null);

    return (
        <Draggable
            nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
            handle="#alert-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'} >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const MaintenanceModeConfirmationModal = (fieldProps: MaintenanceModeConfirmationDialogModel) => {
    fieldProps = { ...new MaintenanceModeConfirmationDialogModel(), ...fieldProps };

    //Use States
    //Variables

    return <Dialog {...{
        PaperComponent: DraggablePaperComponent,
        open: fieldProps?.openDialog ?? false,
        onClose: () => {
            if(fieldProps?.handleClose) {
                fieldProps.handleClose();
            }
        },
        'aria-labelledby': "customized-dialog-title",
        'aria-describedby': "alert-dialog-description",
        TransitionProps: {
            onExited: () => {
                if(fieldProps?.handleClose) {
                    fieldProps.handleClose();
                }
            }
        },
    }} >
        <DialogTitle style={{ cursor: 'move' }} id="alert-dialog-title">Confirm</DialogTitle>

        <CustomDialogContent>
            <DialogContentText id="alert-dialog-description">
                Enable maintenance mode for <span className='instanceName'>{fieldProps?.instanceName}</span>? Production stays fully accessible to users — a temporary, 
                isolated debug clone is spun up so you can safely debug against real data. 
                The clone is removed automatically when you exit. 
                Live production data is never touched.
            </DialogContentText>
        </CustomDialogContent>

        <DialogActions>
            <CustomButton
                btnType={ButtonType.CANCEL_LIGHT}
                title='Close'
                onClick={(e: any) => {
                    e.preventDefault();
                    if(fieldProps?.handleClose) {
                        fieldProps.handleClose();
                    }
                }} />

            <CustomButton
                btnType={ButtonType.PRIMARY_NO_BG}
                title='Confirm'
                onClick={(e: any) => {
                    if(fieldProps?.buttonAction) {
                        fieldProps.buttonAction();
                    }
                }} />
        </DialogActions>
    </Dialog >
}

export default MaintenanceModeConfirmationModal;
